<template>
  <div class="reportpage">
    <div class="loader" :class="{'is-hidden': !loading}">
      <div class="loader__content">
        <i class="loader__spinner fa fa-cog fa-spin"></i>
        <div class="loader__text">
          <div class="loader__heading">Generating report</div>
          <div class="loader__subhead text-info">This could take some time&hellip;</div>
        </div>
      </div>
    </div>

    <div class="buttons">
      <b-button size="sm" variant="primary" @click="reportPrint(); $emit('reportPrint')" class="mx-3">
        <i class="fa fa-print"></i>&ensp;Print
      </b-button>
      <b-button size="sm" variant="outline-danger" @click="$emit('reportClosed')">
        <i class="fa fa-times"></i>&ensp;Close
      </b-button>
    </div>

    <div class="page__header">
      <h1 class="page__title text-secondary">Market Dynamics</h1>
      <h2 class="page__subtitle text-primary" v-html="this.reportLocationAddress"></h2>
      <h1 class="page__logo text__bauhaus">mDory</h1>
    </div>

    <div class="charts">
      <div class="chart chart--earnings">
        <h3 class="chart__title">Earnings</h3>
        <MdoryBarChart :chart-data="earningsdata" :options="earningsoptions" :height="250"></MdoryBarChart>
      </div>
      <div class="chart chart--score">
        <h3 class="chart__title">Mdory Score <span class="chart__score" v-html="parseNumber(reportLocationScore)">xx</span></h3>
        <MdoryBarChart :chart-data="scoredata" :options="scoreoptions" :height="250"></MdoryBarChart>
      </div>
      <div class="chart chart--labor">
        <h3 class="chart__title">Labor Market Totals</h3>
        <MdoryBarChart :chart-data="employmentdata" :options="employmentoptions" :height="600"></MdoryBarChart>
      </div>
      <div class="chart chart--demos">
        <h3 class="chart__title">Demographics</h3>
        <MdoryDataTable :table-data="demographicdata"></MdoryDataTable>
      </div>
      <div class="chart chart--buildings">
        <h3 class="chart__title">Built Environment</h3>
        <MdoryDataTable :table-data="buildingdata"></MdoryDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import MdoryBarChart from './MdoryBarChart.vue';
import MdoryDataTable from './MdoryDataTable.vue';
import axios from 'axios';
import Vue from 'vue';
import swal from 'sweetalert';

export default {
    name: 'reportpage',
    components: {
        MdoryDataTable,
        MdoryBarChart
    },
    props: ['reportPoint', 'reportLocation'],
    mounted: function() {
        this.queryReportData();
    },
    computed: {
        driveTime0Label: function() {
            if(!this.reportLocation) { return '0';}
            if( this.reportLocation.traveltime == 1) {
                return '15';
            }
            return '20';
        },
        driveTime1Label: function() {
            if(!this.reportLocation) { return '0';}
            if( this.reportLocation.traveltime == 1) {
                return '30';
            }
            return '40';
        },
        scoredata: function() {
            return {
              labels: ['Location', this.driveTime0Label + ' min', this.driveTime1Label + ' min'],
              datasets: this.scoredata_datasets,
            };
        },
        reportLocationScore: function() {
            if(this.reportLocation) { return this.reportLocation.score;}
            return 0;
        },
        reportLocationAddress: function() {
            if(this.reportLocation) { return this.reportLocation.address;}
            return '';
        }
    },
    data() {
        return {
            driveTime0: '20',
            driveTime1: '40',
            htmlContent: 'no data yet...',
            isHidden: true,
            loading:false,
            demographicdata: [],
            buildingdata: [],
            employmentdata: {
              labels: ['Information', 'Financial', 'Real Estate', 'Professional', 'Management', 'Education', 'Healthcare', 'Arts', 'Food', 'Other', 'Public Sector', 'Retail'],
              datasets: [
                {
                  label: '60 min travel',
                  backgroundColor: '#f87979',
                  data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                },{
                  label: '30 min travel',
                  backgroundColor: '#f89999',
                  data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }
              ]
            },
            employmentoptions: {
              scales: {
                yAxes: [{
                  gridLines: {
                    display: false
                  }
                }]
              }
            },
            earningsdata: {
              labels: ['Mean Qtly Wages', 'Establishments', 'Total Wkly Wages', 'Avg Wkly Wages'],
              datasets: [
                {
                  label: '60 min travel',
                  backgroundColor: '#a849a8',
                  data: [0, 0, 0, 0, 0, 0, 0]
                },{
                  label: '30 min travel',
                  backgroundColor: '#c869c9',
                  data: [0, 0, 0, 0, 0, 0, 0]
                }
              ]
            },
            earningsoptions: {
              scales: {
                yAxes: [{
                  gridLines: {
                    display: false
                  }
                }]
              }
            },
            scoredata_datasets: [
                {
                  label: '',
                  backgroundColor: '#40a838',
                  data: [0, 0, 0]
                },{
                  label: '',
                  backgroundColor: '#80C878',
                  data: [0, 0, 0]
                },{
                  label: '',
                  backgroundColor: '#a0ee88',
                  data: [0, 0, 0]
                }
            ],
            scoreoptions: {
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  gridLines: {
                    display: false
                  }
                }],
                xAxes: [{
                  ticks: {
                    callback: function(value, index, values) { return ''; },
                  },
                  gridLines: {
                    display: false
                  }
                }]
              }
            }
        }
    },
    methods: {
      reportPrint() {
        window.print();
      },

      parseNumber(val, mindecimal) {
        if (!mindecimal) { mindecimal=0; }
        return parseFloat(val).toLocaleString('en-US', {
          minimumFractionDigits: mindecimal,
          maximumFractionDigits: mindecimal
        });
      },

      queryReportData() {
        if (this.reportLocation == null) {
              return;
        }
        this.loading = true;
        var self = this;


        this.$set(this.scoredata_datasets, 
            this.scoredata_datasets.filter( (item, idx) => {
                if (idx == 0) { item.data = [ this.parseNumber(self.reportLocation.score), 0, 0]; return item;}
                if (idx == 1) { item.data = [ 0, this.parseNumber(self.reportLocation.isozeroscore), 0]; return item;}
                if (idx == 2) { item.data = [ 0, 0, this.parseNumber(self.reportLocation.isoonescore)]; return item;}
            })
        );
        //trigger redraw
//        this.$set(this.scoredata, this.scoredata); 

        var url = process.env.VUE_APP_REPORT_BASE_URI+'/report?lat='+this.reportPoint[1]+'&lon='+this.reportPoint[0];
        // var url = '/report-sample.json';
        axios['get'](url)
        .then(function(response){
            if ( response.data.status && response.data.status == 'error') {
                self.loading = false;
                return;
            }
            let reportdata = response.data;
            let datasets = [];
            datasets = self.employmentdata.datasets.filter( (item, idx) => {
              item.data = reportdata['employmentdata'][idx];
              return item;
            });
            self.$set(self.employmentdata.datasets, datasets);
            //this is to trigger chartjs to redraw
            self.$set(self.employmentdata, self.employmentdata);

            datasets = [];
            datasets = self.earningsdata.datasets.filter( (item, idx) => {
              item.data = reportdata['earningsdata'][idx];
              return item;
            });
            self.$set(self.earningsdata.datasets, datasets);
            //this is to trigger chartjs to redraw
            self.$set(self.earningsdata, self.earningsdata);

            self.flipBuildingTableData(reportdata['building']);
            self.flipDemographicTableData(reportdata['demographics']);
            self.loading = false;
        },function(response) {
            swal("Ooops!","Error fetching data for report","error");
            self.loading = false;
            return;
        });
      },

      flipDemographicTableData(data) {
          this.demographicdata = [
              ['Mean Population', this.parseNumber(data[0][0]), this.parseNumber(data[1][0])],
              ['Mean Households', this.parseNumber(data[0][1]), this.parseNumber(data[1][1])],
              ['Mean House  Value', this.parseNumber(data[0][2]), this.parseNumber(data[1][2])],
              ['Unemployment ', this.parseNumber(data[0][3]), this.parseNumber(data[1][3])]
          ];
          console.log(data);
      },

      flipBuildingTableData(data) {
          this.buildingdata = [
              ['Mean Dist to Highway', this.parseNumber(data[0][0]), this.parseNumber(data[1][0])],
              ['Mean Dist to Airports', this.parseNumber(data[0][1]), this.parseNumber(data[1][1])],
              ['CSA Centroid Dist ', this.parseNumber(data[0][2]), this.parseNumber(data[1][2])],
              ['Mean Dist to Railroads ', this.parseNumber(data[0][3]), this.parseNumber(data[1][3])],
              ['Mean Walkability ', this.parseNumber(data[0][4]), this.parseNumber(data[1][4])]
          ];
          console.log(data);
      }
    }
}
</script>

<style lang="scss">
@page {
  margin: 1in;
}

.reportpage  {
  page-break-after: always;

  @media screen {
    margin: auto;
    width: 10.5in;
  }

  .loader {
    align-items: center;
    background: rgba(black, .8);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: fixed;
    text-align: center;
    top: 0;
    width: 100%;
    z-index: 800;

    &.is-hidden {
      display: none;
    }

    &__content {
      color: white;
    }

    &__spinner {
      animation-duration: 1s;
      font-size: 3rem;
      margin: 1rem;
    }

    &__heading,
    &__subhead {
      animation: slide-in 3s cubic-bezier(0.075, 0.820, 0.165, 1.000) infinite both;
    }

    &__heading {
      font-size: 1.125rem;
      font-weight: bold;
    }

    &__subhead {
      animation-delay: .2s;
    }
  }

  .page__header {
    margin-bottom: 5rem;
  }

  .page__title {
    font-size: 2.5rem;
    font-weight: bold;
  }

  .page__subtitle {
    font-size: 2rem;
  }

  .page__logo {
    float:right;
  }

  .text__bauhaus {
    font-family: 'Bauhaus93';
  }

  .buttons {
    margin: 1rem;
    text-align: right;

    @media print {
      display: none;
    }
  }

  .charts {
    display: grid;
    grid-gap: 1in;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "earnings score"
      "labor labor"
      "demos buildings";
    margin-bottom: 1in;
  }

  .chart {
    position: relative;

    &--earnings { grid-area: earnings; }
    &--labor { grid-area: labor; }
    &--demos { grid-area: demos; }
    &--buildings { grid-area: buildings; }
  }

  .chart__title {
    color: #253494;
    font-size: 1.25rem;
    font-weight: bold;
  }

  .chart__score {
    color: #18a81b;
    font-size: 2rem;
    margin-left: .5rem;
    vertical-align: -.25rem;
  }
}

@keyframes slide-in {
  0% {
    opacity: 0;
    transform: scale(1.1) translateY(50%);
  }

  70% {
    opacity: 1;
    transform: none;
  }

  71% {
    opacity: 1;
    transform: none;
  }

  80% {
    opacity: 0;
    transform: scale(.9) translateY(-30%);
  }

  100% {
    opacity: 0;
    transform: scale(1.1) translateY(50%);
  }
}
</style>
